<template>
  <div class="title">
    <div
      class="left"
      :class="icon == 'fengche' ? 'fengche' : icon == 'zhengfu' ? 'zhengfu' : ''"
      :style="{ background: background == 'false' ? color : background }"
    ></div>
    <div class="text" :style="{ color: color }">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "捐助金额"
    },
    icon: {
      type: String,
      default: "false"
    },
    color: {
      type: String,
      default: "#ffffff"
    },
    background: {
      type: String,
      default: "false"
    }
  },
  data: function() {
    return {};
  },
  mounted() {
    // this.makeCode(this.identifyCodes, 4);
  },
  created() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.title {
  overflow: hidden;
  padding-left: 11px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  text-align: left;
  line-height: 38px;
  .left {
    width: 5px;
    height: 20px;
    background: #ffffff;
    margin-top: 8px;
  }
  .text {
    float: left;
    margin-left: 12px;
  }
  .fengche {
    width: 20px;
    height: 20px;
    background: url(../assets/fengche.png) no-repeat center / 100% 100%;
  }
  .zhengfu {
    width: 20px;
    height: 20px;
    background: url(../assets/guohui.png) no-repeat center / 100% 100%;
  }
}
</style>
